/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InApp/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Attachments from './Attachments/index'
import AutoUploadAttachments from './AutoUploadAttachments/index'
import Documents from './Documents/index'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import FileUploaderPluginUI from 'DesignSystem/FileUploaderPluginUI/react'
import FileUploaderPluginVaxiomFiles from 'DesignSystem/FileUploaderPluginVaxiomFiles/react'
import PaperClipIcon from 'DesignSystem/Svgs/PaperClipIcon/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function InApp({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp",
  isSubmitting
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let messageComposeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnOpen({
  children,
  viewPath,
  isSubmitting
  
})
let threadParentCompanyIdValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'parent_company_id',
})
let threadIdValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'id',
})
let aggregateData = fromAggregate.attachmentsPrefix(threadParentCompanyIdValueData, threadIdValueData)
let threadParentCompanyIdValueData1 = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'parent_company_id',
})
let threadIdValueData1 = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'id',
})
let aggregateData1 = fromAggregate.attachmentsPrefix(threadParentCompanyIdValueData1, threadIdValueData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="normal"
 data="message_compose"
 disabled={messageComposeIsSubmittingData}
 onClick={onClick}
 marginRight={dtSpaceXxs}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<PaperClipIcon
{...childProps}
  viewPath={`${viewPath}/PaperClipIcon`}
 width={16}
 height={16}
 fill="transparent"
 stroke="rgba(0,0,0,0.7)"
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<AutoUploadAttachments
  viewPath={`${viewPath}/AutoUploadAttachments`}
/>
<FileUploaderPluginS3
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 data="thread.parent_company_id"
 data="thread.id"
 aggregate="/Data/aggregate.js attachmentsPrefix"
 prefix={aggregateData}
/>
<FileUploaderPluginVaxiomFiles
  viewPath={`${viewPath}/FileUploaderPluginVaxiomFiles`}
 data="thread.parent_company_id"
 data="thread.id"
 aggregate="/Data/aggregate.js attachmentsPrefix"
 prefix={aggregateData1}
/>
<FileUploaderPluginUI
  viewPath={`${viewPath}/FileUploaderPluginUI`}
 name="Documents"
 onMount={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Documents/Content'))}
 onUnmount={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Documents/No'))}
>
{childProps => (
<Documents
{...childProps}
  viewPath={`${viewPath}/Documents`}
/>
)}
</FileUploaderPluginUI>
<Attachments
  viewPath={`${viewPath}/Attachments`}
/>
{children}
</React.Fragment>)
}